import type { FormControlGroupProps } from './FormControlGroup.typed';
import { ElementProps } from '../FormControl/FormControl.types';
import React, { ReactNode } from 'react';
import { LabelProps } from '../Label/Label.types';
import Space from '../Space/Space';
import { Grid, GridItem } from '../Grid/Grid';
import withDefaultProps from '../../hoc/withDefaultProps';
import Label from '../Label/Label';

const getFormControlLegend = (children: ReactNode) => {
  return React.Children.toArray(children).find(
    (child) => React.isValidElement(child) && child.type === Legend,
  );
};

const getFormControls = (children: ReactNode) => {
  return React.Children.toArray(children).filter(
    (child) => React.isValidElement(child) && child.type !== Legend,
  );
};

const FormControlGroup = (props: FormControlGroupProps) => {
  const { children, required = false } = props;
  const legend = getFormControlLegend(children);
  const formControls = getFormControls(children);

  const legendWithProps =
    React.isValidElement(legend) &&
    React.cloneElement(legend as ElementProps<LabelProps>, {
      required,
    });

  // TODO: Add support for custom grid spacing via props when we use FormControlGroup in more than one location.
  // It's fine for now.
  return (
    <fieldset>
      {legendWithProps}
      <Space space={{ lg: 'S8' }} />
      <Grid columnSpacing={{ lg: 'M24' }} rowSpacing={{ md: 'M24' }}>
        {formControls.map((item, index) => (
          <GridItem xs={12} lg={'shrink'} key={index}>
            {item}
          </GridItem>
        ))}
      </Grid>
    </fieldset>
  );
};

const Legend = withDefaultProps(Label, {
  as: 'legend',
});

export default Object.assign(FormControlGroup, { Label: Legend });
